import { html, KompisElement } from '@inter-ikea-kompis/web-component';
/**
 * Component that can render in an opened or closed state.
 */
export default class AccordionItemPadding extends KompisElement {
    /**
     * Renders the component.
     *
     * @returns Template.
     */
    render() {
        return html `
			<style>
				:host {
					display: block;
				}
			</style>
			<slot></slot>
		`;
    }
}
//# sourceMappingURL=AccordionItemPadding.js.map